import axios from "axios";
import {
  getAllMetadataFailure,
  getAllMetadataRequest,
  getAllMetadataSuccess,
  getSingleMetadataFailure,
  getSingleMetadataRequest,
  getSingleMetadataSuccess,
  metadataFailure,
  metadataRequest,
  metadataSuccess,
  updateMetadataFailure,
  updateMetadataRequest,
  updateMetadataSuccess,
} from "../slices/metaDataSclice";
import { mainurl } from "./mainurl";
const baseurl = mainurl;

export const MetaDataCreate = (formdata) => async (dispatch) => {
  try {
    dispatch(metadataRequest());
    const { data } = await axios.post(
      `${baseurl}/meta-data/cteate_metadata`,
      formdata,
      { withCredentials: true }
    );
    dispatch(metadataSuccess(data));
    return data;
  } catch (error) {
    const message = error?.response?.data?.message || "Unable to create metadata";
    dispatch(metadataFailure(message));
    throw error;
  }
};

export const getMetaDataCreate = async (dispatch) => {
  try {
    dispatch(getAllMetadataRequest());
    const { data } = await axios.get(`${baseurl}/meta-data/Getmetadata`);
    dispatch(getAllMetadataSuccess(data));
  } catch (error) {
    dispatch(getAllMetadataFailure(error.response.data.message));
  }
};

export const getSingleMetaData =(id)=> async (dispatch) => {
  try {
    dispatch(getSingleMetadataRequest());
    const { data } = await axios.get(
      `${baseurl}/meta-data/single_metadata/${id}`,
      { withCredentials: true }
    );
    dispatch(getSingleMetadataSuccess(data));
  } catch (error) {
    dispatch(getSingleMetadataFailure(error.response.data.message));
  }
};


export const UpadteMetaData = (formdata,id) => async (dispatch) => {
  try {
    dispatch(updateMetadataRequest());
    const { data } = await axios.put(
      `${baseurl}/meta-data/update_metadata/${id}`,
      formdata,
      { withCredentials: true }
    );
    dispatch(updateMetadataSuccess(data));
  } catch (error) {
    dispatch(updateMetadataFailure(error.response.data.message));
  }
};
